import React from "react"
import { Modal } from "@mimber/ui-web"
import { EventTicketTierForm } from "@/components/forms/EventTicketTierForm"
import type { EditEventTicketTierModalProps } from "./EditEventTicketTierModal.types"

export const EditEventTicketTierModal: React.FunctionComponent<
  EditEventTicketTierModalProps
> = ({ eventUuid, tier, onSuccess, ...modalProps }) => {
  return (
    <Modal footer={null} title="Edit Ticket Tier" {...modalProps}>
      {(close) => (
        <EventTicketTierForm
          eventUuid={eventUuid}
          tier={tier}
          onSuccess={() => {
            close()
            onSuccess?.()
          }}
          onCancel={close}
        />
      )}
    </Modal>
  )
}
